import {UDEMY_RELATIVE_LOGO_URLS} from '@udemy/react-brand-components';

/**
 *  TODO: COPIED FROM https://github.com/udemy/frontends-components/blob/ebae366220b482796f7177ce5b916cb51d999874/packages/footer/src/external/utils/udemy-logo-urls.ts#L14-L13
 *  DO NOT EDIT THIS FILE DIRECTLY. THIS FILE IS COPIED, AND WE SHOULD ULTIMATELY USE AN IMPORTED VERSION OF THIS.
 **/

const assetPath = process.env.ASSET_PREFIX ?? '';

export const udemyLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyLogoUrl}`;
export const udemyLogoInvertedUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyLogoInvertedUrl}`;
export const ubLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.ubLogoUrl}`;
export const ubLogoInvertedUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.ubLogoInvertedUrl}`;
export const ugLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.ugLogoUrl}`;
export const ugLogoInvertedUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.ugLogoInvertedUrl}`;
export const udemyProLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyProLogoUrl}`;
export const udemyBenesseLogoUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyBenesseLogoUrl}`;
export const udemyBenesseLogoInvertedUrl = `${assetPath}${UDEMY_RELATIVE_LOGO_URLS.udemyBenesseLogoInvertedUrl}`;
